import React, { PropTypes } from 'react';
import { GridTile } from 'material-ui/GridList';
import IconButton from 'material-ui/IconButton';
import IconEdit from '../../../Icons/IconEdit';
import IconMove from '../../../Icons/IconMove';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import s from './style';

export class StudioItem extends React.Component {
  static propTypes = {
    isDragging: PropTypes.bool,
    isOver: PropTypes.bool,
    editItem: PropTypes.func.isRequired,
    deleteItem: PropTypes.func.isRequired,
    color: PropTypes.string
  };

  render() {
    const {
      item,
      index,
      isDragging,
      connectDragSource,
      connectDragPreview
    } = this.props;
    // eslint-disable-next-line no-unused-vars
    const classNames = isDragging
      ? s.hoveredItem + ' ' + s.dragging
      : s.hoveredItem;

    return (
      <div style={{height: '100%'}}>
        {connectDragPreview(
          <span>
            <GridTile
              key={index}
              title={item.primaryText}
              subtitle={item.secondaryText}
              titlePosition={'bottom'}
              style={{ height: '100%' }}
              titleStyle={{ maxWidth: '100px' }}
              actionIcon={
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%'
                  }}
                >
                  {connectDragSource(
                    <span>
                      <IconButton style={{ cursor: 'move' }}>
                        <IconMove color={this.props.color} />
                      </IconButton>
                    </span>,
                  )}

                  <IconButton
                    onClick={() => {
                      this.props.editItem(item);
                    }}
                  >
                    <IconEdit color={this.props.color} />
                  </IconButton>
                  <IconButton
                    onClick={event => {
                      event.stopPropagation();
                      event.preventDefault();
                      this.props.deleteItem(item);
                    }}
                  >
                    <DeleteIcon color={this.props.color} />
                  </IconButton>
                </div>
              }
            >
              <img
                src={item.avatar}
                style={{ objectFit: 'contain', width: '100%' }}
              />
            </GridTile>
          </span>,
        )}
      </div>
    );
  }
}

export default StudioItem;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/DragItems/DraggableItem/StudioItem.js